// @ts-nocheck
export const tzOffset = new Date().getTimezoneOffset() * 60000;

export const applyTimeZoneOnDate = (date: Date) => {
    const offset = date.getTimezoneOffset() * 60000;
    return new Date(new Date(date).getTime() + offset);
};

export const removeTimeZoneOnDate = (date: Date) => {
    const offset = date.getTimezoneOffset() * 60000;

    return new Date(new Date(date).getTime() - offset);
};
